module.exports = __webpack_public_path__ + "static/media/fundacion_irsa.db60d372.jfif";